var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-particles',{attrs:{"color":"#fff","particleOpacity":0.7,"particlesNumber":80,"shapeType":"circle","particleSize":4,"linesColor":"#dedede","linesWidth":1,"lineLinked":true,"lineOpacity":0.4,"linesDistance":150,"moveSpeed":3,"hoverEffect":true,"hoverMode":"grab","clickEffect":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }